import { EMPTY_FIELD } from 'constants/emptyField';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { StyledChipField } from 'pages/Finance/ProviderAccounts/ProviderAccountsList/ProviderAccountsList.styled';
import { Box } from 'shared/mui/Box';
import {
  EmbeddedArrayField,
  EmbeddedArrayFieldProps,
} from 'shared/react-admin/Fields/Embedded/EmbeddedArrayField/EmbeddedArrayField';
import { Link } from 'shared/react-admin/Links/Link';

export const ProviderAccountsMerchantsField: React.FC<EmbeddedArrayFieldProps> = ({
  label,
  ...restProps
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();

  return (
    <EmbeddedArrayField
      label={label}
      render={(values) => (
        <Box display="flex" flexWrap="wrap" gap="4px">
          {values.map((v, index) => {
            const path = createPathWithQuery({
              resource: 'merchants',
              id: v['@id'],
              type: 'show',
            });

            return (
              <Link key={v?.['@id'] || index} to={path}>
                <StyledChipField
                  color="default"
                  emptyText={EMPTY_FIELD}
                  record={v}
                  source="name"
                  sx={{ color: 'blue!important' }}
                />
              </Link>
            );
          })}
        </Box>
      )}
      {...restProps}
    />
  );
};
